import { ColorSchemeName } from 'react-native';
import { useMatchMedia } from './useMatchMedia';

export default function useColorScheme(): NonNullable<ColorSchemeName> {
  const scheme = useMatchMedia('(prefers-color-scheme: dark)')
    ? 'dark'
    : 'light';
  return scheme;
}
